module.exports = __webpack_public_path__ + "img/ai-wechat-qrcode-v3.f6b9ff1f.png";